import { render } from "./Write.vue?vue&type=template&id=527caf1d&scoped=true"
import script from "./Write.vue?vue&type=script&lang=js"
export * from "./Write.vue?vue&type=script&lang=js"

import "./Write.vue?vue&type=style&index=0&id=527caf1d&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527caf1d"]])

export default __exports__